import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCommon } from "@obg/common.config";
import { ConfigService } from "@obg/ngx.global";

@Injectable({
	providedIn: "root",
})
export class SeamlessRegistrationConfigService {
	constructor(private configService: ConfigService<ObgConfigFeAdaptiveClientCommon>) {}

	getSeamlessRegistrationEndpoint(): string {
		return this.configService.get(
			(x) => x.common.seamlessRegistration.endpoints!.seamlessRegistration,
			"v1/seamlessregistrations"
		);
	}
}
